<template>
  <transition leave-active-class="duration-200">
    <div
      @keydown="$refs.progressbar.userKeyDown()"
      @keyup="$refs.progressbar.userKeyUp()"
      @click="calculate_progress"
      v-if="showing === true && loadingData === false"
      class="z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex items-center justify-center"
    >
      <!-- Background modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          class="fixed inset-0 transition-opacity"
          @click="closePopup()"
        >
          <div class="absolute inset-0 bg-indigo-600 bg-opacity-85" />
        </div>
      </transition>
      <!-- FIN Background modal -->

      <!-- Content modal -->
      <div
        aria-labelledby="modal-headline"
        aria-modal="true"
        class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-scroll max-h-9/10 shadow-xl transform transition-all lg:w-4/6 sm:w-full sm:p-6"
        role="dialog"
        @scroll="$refs.progressbar.reduceProgressBar($event)"
      >
        <div
          class="cursor-pointer absolute right-5 top-20 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
          @click="closePopup()"
        >
          <icon name="close" />
        </div>
        <div class="sticky flex flex-col items-center top-0 z-10">
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              v-if="messageHeader.type != '' && messageHeader.msg != ''"
              :class="{
                'bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600':
                  messageHeader == 'saveIsSuccess' ||
                  messageHeader == 'transferIsSuccess',
                'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600':
                  messageHeader == 'error' ||
                  messageHeader == 'noName' ||
                  messageHeader == 'lastActivity' ||
                  messageHeader === 'evaluationInProgress',
                'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600':
                  messageHeader == 'noSave',
              }"
              class="absolute z-50 min-w-max text-center py-5 mt-10 text-base flex items-center justify-center"
            >
              <div>
                <div class="flex items-center justify-center">
                  <icon
                    v-if="
                      messageHeader == 'saveIsSuccess' ||
                        messageHeader == 'transferIsSuccess'
                    "
                    name="checkmark-circle-2"
                    class="inline-block mr-2"
                  />
                  <icon
                    v-else-if="
                      messageHeader == 'error' ||
                        messageHeader == 'noName' ||
                        messageHeader == 'lastActivity'
                    "
                    name="alert-triangle"
                    class="inline-block mr-2"
                  />
                  <icon
                    v-else-if="messageHeader == 'noSave'"
                    name="alert-triangle"
                    class="inline-block mr-2"
                  />

                  <div v-if="messageHeader == 'saveIsSuccess'">
                    Vos données ont été enregistrées.
                  </div>
                  <div v-if="messageHeader == 'transferIsSuccess'">
                    La fiche de poste à bien été transférée.
                  </div>
                  <div v-if="messageHeader == 'evaluationInProgress'">
                    Vous ne pouvez pas modifier une fiche de poste utilisée par
                    une évaluation.
                  </div>
                  <div v-if="messageHeader == 'error'">
                    Erreur d'enregistrement des données.
                  </div>
                  <div v-if="messageHeader == 'lastActivity'">
                    Vous ne pouvez pas supprimer la dernière activité.
                  </div>
                  <div v-if="messageHeader == 'noName'">
                    Veuillez remplir le champ "nom du poste"
                    <br>
                    pour enregistrer la fiche.
                  </div>
                  <div v-if="messageHeader == 'noSave'">
                    Vous avez des modifications non sauvegardées.<br>
                  </div>
                </div>

                <div
                  v-if="messageHeader == 'noSave'"
                  class="mt-5"
                >
                  <button
                    @click="cancel_nosave()"
                    class="border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2 mr-4"
                  >
                    ANNULER
                  </button>

                  <button
                    @click="closeWithoutSaving()"
                    class="bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2"
                  >
                    QUITTER
                  </button>
                </div>
              </div>
            </div>
          </transition>
          <!-- Save button -->
          <div
            v-if="
              editable &&
                $can(constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER)
            "
            class="absolute right-15 mt-13 flex items-center justify-center"
          >
            <div
              v-if="saving"
              class="w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
            >
              <span class="h-6 w-6 ml-4 mt-1/4 spinner spinner-save" />
            </div>
            <div
              v-else
              class="rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14"
              @click="save_datas"
            >
              <icon
                class="h-6 w-6 ml-4 mt-1/4"
                name="save"
              />
            </div>
          </div>

          <div
            v-else-if="
              !editable &&
                $can(constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_EDITER)
            "
            class="absolute right-15 mt-13 flex items-center justify-center"
          >
            <div
              v-if="saving"
              class="w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
            >
              <span class="h-6 w-6 ml-4 mt-1/4 spinner spinner-save" />
            </div>
            <div
              v-else
              class="rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14"
              @click="save_datas"
            >
              <icon
                class="h-6 w-6 ml-4 mt-1/4"
                name="save"
              />
            </div>
          </div>
        </div>

        <!-- Progress bar -->
        <progress-bar
          v-if="editable"
          ref="progressbar"
          :in-popup="true"
        />
        <!-- End Progress bar -->

        <!-- Content form -->
        <div class="m-5 md:m-15 grid grid-cols-12">
          <h3
            class="col-span-full"
            v-if="form.nom_du_poste == '' || form.nom_du_poste == null"
          >
            Nouveau poste
          </h3>

          <h3
            class="col-span-full"
            v-else
          >
            {{ form.nom_du_poste }}
          </h3>

          <!-- BEGIN informations de base -->
          <h4 class="col-span-full text-indigo-600 my-10">
            Informations de base
          </h4>

          <div class="col-span-full grid grid-cols-12 gap-4">
            <input-text
              :class="'lg:col-span-4'"
              name="nom_du_poste"
              libelle="Nom du poste"
              :necessary="true"
              :value="form.nom_du_poste"
              @input="
                (newValue) => {
                  form.nom_du_poste = newValue;
                }
              "
              :disabled="!editable"
            />
            <input-select
              name="sector"
              libelle="Secteur d'activité"
              :necessary="true"
              :datas="categories"
              :value="form.sector"
              @input="
                (newValue) => {
                  form.sector = newValue;
                  setIndex(newValue);
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-select
              name="family"
              libelle="Famille professionnelle"
              :necessary="true"
              :value="form.family"
              @input="
                (newValue) => {
                  form.family = newValue;
                }
              "
              class="lg:col-span-4"
              :datas="listFamilies"
              :disabled="!editable"
            />
            <input-text-area
              name="mission"
              libelle="Mission(s)"
              :size="5"
              :necessary="true"
              :value="form.mission"
              @input="
                (newValue) => {
                  form.mission = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-text-area
              name="objectif"
              libelle="Objectif(s)"
              :size="5"
              :necessary="true"
              :value="form.objectif"
              @input="
                (newValue) => {
                  form.objectif = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-text-area
              name="contexte_organisationnel"
              libelle="Contexte Organisationnel"
              :size="5"
              :necessary="true"
              :value="form.contexte_organisationnel"
              @input="
                (newValue) => {
                  form.contexte_organisationnel = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-text-area
              name="passerelle_mobilité"
              libelle="Passerelle de mobilité"
              :size="5"
              :necessary="true"
              :value="form.passerelle_mobilité"
              @input="
                (newValue) => {
                  form.passerelle_mobilité = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-text-area
              name="formation_experience"
              libelle="Formation(s) - Expérience(s)"
              :size="5"
              :necessary="true"
              :value="form.formation_experience"
              @input="
                (newValue) => {
                  form.formation_experience = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />

            <!-- BEGIN Referentiels correspondants -->
            <div class="col-span-full grid grid-cols-12 gap-4 my-10">
              <h4 class="text-indigo-600 col-span-full">
                Référentiels correspondants
              </h4>
              <input-text
                class="lg:col-span-3"
                name="rome"
                libelle="ROME"
                :necessary="false"
                :value="form.rome"
                @input="
                  (newValue) => {
                    form.rome = newValue;
                  }
                "
                :disabled="!editable"
              />
              <input-text
                class="lg:col-span-3"
                name="rsfp"
                libelle="RSFP"
                :necessary="false"
                :value="form.rsfp"
                @input="
                  (newValue) => {
                    form.rsfp = newValue;
                  }
                "
                :disabled="!editable"
              />
              <input-text
                class="lg:col-span-3"
                name="rncp"
                libelle="Diplômes et titre (RNCP)"
                :necessary="false"
                :value="form.rncp"
                @input="
                  (newValue) => {
                    form.rncp = newValue;
                  }
                "
                :disabled="!editable"
              />
              <input-text
                class="lg:col-span-3"
                name="convention_collective"
                libelle="Conventions collectives"
                :necessary="false"
                :value="form.convention_collective"
                @input="
                  (newValue) => {
                    form.convention_collective = newValue;
                  }
                "
                :disabled="!editable"
              />
            </div>
            <!-- END Referentiels correspondants -->

            <!-- BEGIN Liste activités -->
            <div class="relative col-span-full">
              <div class="my-10">
                <div
                  class="w-full flex flex-col justify-center items-center mb-10"
                >
                  <div class="max-w-8/10 flex flex-col items-end">
                    <div
                      class="flex flex-row justify-center items-center cursor-pointer w-full"
                      @click="displayActivitylist"
                      @click.stop
                    >
                      <div class="flex flex-row items-end justify-center ml-2">
                        <h4 class="text-indigo-600 text-center select-none">
                          {{ activityTitle }}
                        </h4>
                      </div>
                      <div
                        class="text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
                      >
                        <icon
                          class="h-4 w-4"
                          name="chevron-down"
                        />
                      </div>
                    </div>
                    <div class="activitylist relative w-60 h-0">
                      <div
                        class="absolute w-full flex z-20 rounded-md bg-white shadow-md shadow-gray-600 text-sm right-0"
                        v-click-outside="displayActivitylist"
                        v-if="showList"
                      >
                        <div class="mx-5 my-3">
                          <div class="text-left">
                            <div
                              class="first:pt-2 py-1"
                              v-for="(activity, i) in form.activities"
                              :key="i"
                            >
                              <p
                                class="text-gray-600 hover:text-gray-900 cursor-pointer"
                                @click="currentActivity = i"
                              >
                                <span>{{
                                  'Activité ' +
                                    (i + 1) +
                                    ' : ' +
                                    activity.activity_name
                                }}</span>
                              </p>
                            </div>
                            <div
                              @click="addActivity"
                              class="border-t pt-2 mt-5 text-gray-600 hover:text-gray-900 cursor-pointer"
                              v-if="editable"
                            >
                              <span>Ajouter une activité</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex items-center justify-between mb-10"
                  v-if="editable"
                >
                  <delete-button
                    libelle="Supprimer l'activité"
                    @del="deleteActivity"
                  />
                  <div class="flex-none w-max relative">
                    <action-button
                      responsive
                      bg-color="bg-orange-300"
                      bg-color-square="bg-orange-100"
                      border-color="border-transparent"
                      icon="swap"
                      icon-color="text-orange-600"
                      libelle="Intervertir les activités"
                      text-color="text-gray-900"
                      @clickAction="displayInvertActivitiesMenu"
                    />
                    <div
                      v-if="isInvertActivitiesMenuDisplayed"
                      v-click-outside="hideInvertActivitiesMenu"
                      class="z-20 absolute right-0 top-13 text-sm w-max max-w-md bg-white rounded-md shadow-md shadow-gray-600 px-6 py-5 cursor-default flex flex-col space-y-1"
                    >
                      <draggable
                        v-model="form.activities"
                        @start="drag = true"
                        @end="drag = false"
                        v-bind="dragOptions"
                      >
                        <transition-group
                          enter-active-class="ease-in duration-1000"
                          enter-class="bg-indigo-300 border-0 rounded-xl"
                          enter-to-class="bg-none border-0 rounded-xl"
                          leave-active-class="linear duration-1000"
                          leave-class="h-20 opacity-100"
                          leave-to-class="h-0 opacity-0"
                          tag="div"
                        >
                          <div
                            v-for="(activity, iAct) in form.activities"
                            :key="'A' + iAct"
                          >
                            <div
                              class="grid grid-cols-12 cursor-pointer items-center"
                            >
                              <icon
                                name="move"
                                class="text-indigo-600 col-span-1"
                              />
                              <p
                                class="text-gray-600 hover:text-gray-900 col-span-11"
                              >
                                {{ activity.activity_name }}
                              </p>
                            </div>
                            <hr
                              v-if="iAct < form.activities.length - 1"
                              class="my-2.5 border-indigo-300"
                            >
                          </div>
                        </transition-group>
                      </draggable>
                    </div>
                  </div>
                </div>

                <div
                  v-for="(activity, index) in form.activities"
                  :key="'activitygeneral' + index"
                >
                  <div v-show="currentActivity === index">
                    <div class="grid grid-cols-12 gap-4">
                      <input-text
                        class="lg:col-span-3"
                        name="activity_name"
                        libelle="Activité"
                        :necessary="true"
                        :value="form.activities[index].activity_name"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_name = newValue;
                          }
                        "
                        :disabled="!editable"
                      />
                      <input-select
                        name="evolution"
                        libelle="Evolution de l'activité en N+1"
                        :necessary="true"
                        :datas="[
                          { value: 'Reconduite' },
                          { value: 'Modifiée' },
                          { value: 'Supprimée' },
                          { value: 'Renforcée' },
                        ]"
                        :value="form.activities[index].activity_evolution"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_evolution =
                              newValue;
                          }
                        "
                        class="lg:col-span-3"
                        :disabled="!editable"
                      />
                      <input-select
                        name="situation"
                        libelle="Situation de l'activité"
                        :necessary="true"
                        :datas="[
                          { value: 'Individuelle' },
                          { value: 'Collective' },
                          { value: 'Individuelle et collective' },
                        ]"
                        :value="form.activities[index].activity_situation"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_situation =
                              newValue;
                          }
                        "
                        class="lg:col-span-3"
                        :disabled="!editable"
                      />
                      <input-select
                        name="posture"
                        libelle="Posture de travail"
                        :necessary="true"
                        :datas="[
                          { value: 'Statique assis' },
                          { value: 'Statique debout' },
                          { value: 'En mouvement' },
                        ]"
                        :value="form.activities[index].activity_posture"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_posture = newValue;
                          }
                        "
                        class="lg:col-span-3"
                        :disabled="!editable"
                      />
                      <input-select
                        name="risque"
                        libelle="Activité à risque"
                        :necessary="true"
                        :datas="[{ value: 'Oui' }, { value: 'Non' }]"
                        :value="form.activities[index].activity_risk"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_risk = newValue;
                          }
                        "
                        class="lg:col-span-3"
                        :disabled="!editable"
                      />
                      <input-text
                        v-if="form.activities[index].activity_risk === 'Oui'"
                        name="risktype"
                        libelle="Type de risque"
                        :necessary="true"
                        :value="form.activities[index].activity_risktype"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_risktype = newValue;
                          }
                        "
                        :class="
                          (form.activities[index].activity_risk == 'Oui'
                            ? 'lg:col-span-3'
                            : 'lg:col-span-0') + ' transition'
                        "
                        :disabled="!editable"
                      />
                      <multiple-select
                        name="outillage"
                        libelle="Outillage utilisé"
                        :necessary="true"
                        :value="form.activities[index].activity_tools"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_tools = newValue;
                          }
                        "
                        :datas="[
                          { value: 'Poste sans outillage' },
                          { value: 'Outil informatique' },
                          { value: 'Petit outillage' },
                          { value: 'Machine simple' },
                          { value: 'Machine complexe' },
                          { value: 'Machines et outillages divers' },
                        ]"
                        class="lg:col-span-3"
                        :disabled="!editable"
                      />
                      <input-select
                        name="time"
                        libelle="Temps consacré"
                        :necessary="true"
                        :datas="[
                          { value: 'Majeur (+ de 50% du temps)' },
                          { value: 'Secondaire (- de 50% du temps)' },
                          { value: 'Mineur (- de 10% du temps)' },
                        ]"
                        :value="form.activities[index].activity_time"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_time = newValue;
                          }
                        "
                        class="lg:col-span-3"
                        :disabled="!editable"
                      />
                      <input-select
                        name="level"
                        libelle="Niveau de maitrise requis"
                        :necessary="true"
                        :datas="[
                          { value: '1. Connaissance de base' },
                          { value: '2. Intermédiaire' },
                          { value: '3. Confirmé' },
                          { value: '4. Expert' },
                        ]"
                        :value="form.activities[index].activity_level"
                        @input="
                          (newValue) => {
                            form.activities[index].activity_level = newValue;
                          }
                        "
                        class="lg:col-span-3"
                        :disabled="!editable"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-for="(activity, bigindex) in form.activities"
                :key="'activitytasks' + bigindex"
              >
                <div v-show="currentActivity === bigindex">
                  <div class="grid grid-cols-12 gap-y-5 sm:gap-x-10 mb-10">
                    <h5
                      class="text-left text-base uppercase text-indigo-600 col-span-full"
                    >
                      Tâches Principales
                    </h5>

                    <!-- BEGIN Liste tâches -->
                    <draggable
                      v-model="form.activities[bigindex].activity_tasks"
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptions"
                      class="col-span-full grid grid-cols-12 gap-y-5 sm:gap-x-10"
                    >
                      <div
                        v-for="(task, index) in form.activities[bigindex]
                          .activity_tasks"
                        :key="'A' + index"
                        class="col-span-full sm:col-span-6 flex items-center relative"
                      >
                        <input-text-with-action
                          libelle=""
                          :name="'task' + index"
                          :necessary="true"
                          :value="task.name"
                          :disabled="!editable"
                          :is-grabable="true"
                          :style="editable ? 'cursor:grab' : ''"
                          @input="
                            (newValue) => {
                              task.name = newValue;
                            }
                          "
                          @switchDraggable="
                            (newValue) => {
                              isDraggable = newValue;
                            }
                          "
                          @duplicate="duplicateTask(task, index)"
                          @delete="
                            deleteFromActivity(
                              form.activities[bigindex].activity_tasks,
                              index
                            )
                          "
                          :draggable="true"
                          placeholder="Saisir le nom de la tâche"
                          :prefix-text="index + 1 + '. '"
                          :class="{
                            'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50':
                              isFlash.task == index,
                          }"
                        />
                      </div>
                    </draggable>
                    <!-- END Liste tâches -->

                    <add-button
                      libelle="Ajouter une tâche"
                      :disabled="!editable"
                      @add="
                        addToActivity(form.activities[bigindex].activity_tasks)
                      "
                      class="col-span-full flex items-center w-max"
                    />
                  </div>

                  <div class="grid grid-cols-12 gap-y-5 sm:gap-x-10 mb-10">
                    <h5
                      class="text-left text-base uppercase text-indigo-600 col-span-full"
                    >
                      Pratiques professionnelles : être capable de...
                    </h5>

                    <!-- BEGIN Liste Pratiques professionnelles -->
                    <draggable
                      v-model="
                        form.activities[bigindex].activity_pratiques_pros
                      "
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptions"
                      class="col-span-full grid grid-cols-12 gap-y-5 sm:gap-x-10"
                    >
                      <div
                        v-for="(pratiques_pro, index) in form.activities[
                          bigindex
                        ].activity_pratiques_pros"
                        :key="'A' + index"
                        class="col-span-full sm:col-span-6 flex items-center"
                      >
                        <input-text-with-action
                          libelle=""
                          :name="'pratique' + index"
                          :necessary="true"
                          :value="pratiques_pro.name"
                          :disabled="!editable"
                          :is-grabable="true"
                          :style="editable ? 'cursor:grab' : ''"
                          @input="
                            (newValue) => {
                              pratiques_pro.name = newValue;
                            }
                          "
                          @switchDraggable="
                            (newValue) => {
                              isDraggable = newValue;
                            }
                          "
                          @duplicate="duplicatePratique(pratiques_pro, index)"
                          @delete="
                            deleteFromActivity(
                              form.activities[bigindex].activity_pratiques_pros,
                              index
                            )
                          "
                          placeholder="Saisir le nom de la pratique professionnelle"
                          :draggable="true"
                          :prefix-text="index + 1 + '. '"
                          :class="{
                            'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50':
                              isFlash.pratique == index,
                          }"
                        />
                      </div>
                    </draggable>
                    <!-- END Liste Pratiques professionnelles -->
                    <add-button
                      class="col-span-full flex items-center w-max"
                      libelle="Ajouter une pratique professionnelle"
                      :disabled="!editable"
                      @add="
                        addToActivity(
                          form.activities[bigindex].activity_pratiques_pros
                        )
                      "
                    />
                  </div>

                  <div class="grid grid-cols-12 gap-y-5 sm:gap-x-10 mb-10">
                    <h5
                      class="text-left text-base uppercase text-indigo-600 col-span-full"
                    >
                      Connaissances associées : théorique, procédurale...
                    </h5>

                    <!-- BEGIN Liste connaissances -->
                    <draggable
                      v-model="form.activities[bigindex].activity_connaissances"
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptions"
                      class="col-span-full grid grid-cols-12 gap-y-5 sm:gap-x-10"
                    >
                      <div
                        v-for="(connaissance, index) in form.activities[
                          bigindex
                        ].activity_connaissances"
                        :key="'A' + index"
                        class="col-span-full sm:col-span-6 flex items-center"
                      >
                        <input-text-with-action
                          libelle=""
                          :name="'connaissance' + index"
                          :necessary="true"
                          :value="connaissance.name"
                          :disabled="!editable"
                          :is-grabable="true"
                          :style="editable ? 'cursor:grab' : ''"
                          @input="
                            (newValue) => {
                              connaissance.name = newValue;
                            }
                          "
                          @switchDraggable="
                            (newValue) => {
                              isDraggable = newValue;
                            }
                          "
                          @duplicate="
                            duplicateConnaissance(connaissance, index)
                          "
                          @delete="
                            deleteFromActivity(
                              form.activities[bigindex].activity_connaissances,
                              index
                            )
                          "
                          placeholder="Saisir le nom de la connaissance"
                          :draggable="true"
                          :prefix-text="index + 1 + '. '"
                          :class="{
                            'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50':
                              isFlash.connaissance == index,
                          }"
                        />
                      </div>
                    </draggable>
                    <!-- END Liste connaissances -->
                    <add-button
                      libelle="Ajouter une connaissance"
                      :disabled="!editable"
                      class="col-span-full flex items-center w-max"
                      @add="
                        addToActivity(
                          form.activities[bigindex].activity_connaissances
                        )
                      "
                    />
                  </div>

                  <div class="grid grid-cols-12 gap-y-5 sm:gap-x-10 mb-10">
                    <h5
                      class="text-left text-base uppercase text-indigo-600 col-span-full"
                    >
                      Comportement / Attitudes
                    </h5>

                    <!-- BEGIN Liste comportements -->
                    <draggable
                      v-model="form.activities[bigindex].activity_comportements"
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptions"
                      class="col-span-full grid grid-cols-12 gap-y-5 sm:gap-x-10"
                    >
                      <div
                        v-for="(comportement, index) in form.activities[
                          bigindex
                        ].activity_comportements"
                        :key="'A' + index"
                        class="col-span-full sm:col-span-6 flex items-center"
                      >
                        <input-text-with-action
                          libelle=""
                          :name="'comportement' + index"
                          :necessary="true"
                          :value="comportement.name"
                          :disabled="!editable"
                          :is-grabable="true"
                          :style="editable ? 'cursor:grab' : ''"
                          @input="
                            (newValue) => {
                              comportement.name = newValue;
                            }
                          "
                          @switchDraggable="
                            (newValue) => {
                              isDraggable = newValue;
                            }
                          "
                          @duplicate="
                            duplicateComportement(comportement, index)
                          "
                          @delete="
                            deleteFromActivity(
                              form.activities[bigindex].activity_comportements,
                              index
                            )
                          "
                          placeholder="Saisir le nom du comportement"
                          :draggable="true"
                          :prefix-text="index + 1 + '. '"
                          :class="{
                            'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50':
                              isFlash.comportement == index,
                          }"
                        />
                      </div>
                    </draggable>
                    <!-- END Liste comportements -->
                    <add-button
                      libelle="Ajouter un comportement"
                      :disabled="!editable"
                      class="col-span-full flex items-center w-max"
                      @add="
                        addToActivity(
                          form.activities[bigindex].activity_comportements
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END Liste activités -->

          <!-- BEGIN Savoirs fondamentaux -->
          <div class="col-span-full grid grid-cols-12 gap-4 mt-10">
            <h4 class="text-indigo-600 col-span-full">
              Savoirs Fondamentaux
            </h4>

            <input-text-area
              name="lecture"
              libelle="Lecture"
              :size="5"
              :necessary="true"
              :value="form.lecture"
              @input="
                (newValue) => {
                  form.lecture = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />

            <input-text-area
              name="ecriture"
              libelle="Ecriture"
              :size="5"
              :necessary="true"
              :value="form.ecriture"
              @input="
                (newValue) => {
                  form.ecriture = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />

            <input-text-area
              name="calcul"
              libelle="Calcul"
              :size="5"
              :necessary="true"
              :value="form.calcul"
              @input="
                (newValue) => {
                  form.calcul = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />

            <input-text-area
              name="informatique"
              libelle="Informatique"
              :size="5"
              :necessary="true"
              :value="form.informatique"
              @input="
                (newValue) => {
                  form.informatique = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />

            <input-text-area
              name="communication"
              libelle="Communication / Expression"
              :size="5"
              :necessary="true"
              :value="form.communication"
              @input="
                (newValue) => {
                  form.communication = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />

            <input-text-area
              name="autres"
              libelle="Autres (précisez)"
              :size="5"
              :necessary="true"
              :value="form.autres"
              @input="
                (newValue) => {
                  form.autres = newValue;
                }
              "
              class="lg:col-span-4"
            />
          </div>
        </div>
        <!-- END Savoirs fondamentaux -->

        <!-- END Content form -->
      </div>
      <!-- END Content modal -->
    </div>
  </transition>
</template>

<script>
import axios from '../api';
import { mapGetters, mapMutations } from 'vuex';
import ClickOutside from 'vue-click-outside';

import Icon from '../components/Icon';
import Illustration from '../components/Illustration';
import ActionButton from '../components/ActionButton';
import AddButton from '../components/Inputs/AddButton';
import SaveButton from '../components/SaveButton';
import CloseButton from '../components/CloseButton';

import InputText from '../components/Inputs/InputText';
import InputTextWithAction from '../components/Inputs/InputTextWithAction';
import InputTextArea from '../components/Inputs/InputTextArea';
import MultipleSelect from '../components/Inputs/MultipleSelect';
import InputSelect from '../components/Inputs/InputSelect';

import Popup from '../components/Popup';
import PageNotAllowed from '../components/PageNotAllowed';
import ProgressBar from './ProgressBar';

import Constants from './../constants';
import draggable from 'vuedraggable';
import DeleteButton from './Inputs/DeleteButton.vue';

export default {
  props: ['show', 'id', 'openedFromEditButton'],

  components: {
    DeleteButton,
    Icon,
    ActionButton,
    SaveButton,
    InputText,
    InputTextArea,
    MultipleSelect,
    AddButton,
    InputSelect,
    CloseButton,
    PageNotAllowed,
    Popup,
    Illustration,
    draggable,
    InputTextWithAction,
    ProgressBar,
  },

  name: 'PopupFichedeposte',

  data() {
    return {
      loadingData: false,
      editable: true,
      smallBar: false,
      progress: 0,
      goal: 75,
      categories: [],
      showList: false,
      currentActivity: 0,
      messageHeader: '',
      currentSector: '',
      saved: true,
      justLoaded: false,
      form: {},
      emptyForm: {
        nom_du_poste: '',
        sector: '',
        family: '',
        mission: '',
        objectif: '',
        contexte_organisationnel: '',
        passerelle_mobilité: '',
        formation_experience: '',
        activities: [
          {
            activity_name: 'Nom de l\'activité',
            activity_risktype: '',
            activity_level: '',
            activity_tools: [],
            activity_evolution: '',
            activity_tasks: [],
            activity_situation: '',
            activity_posture: '',
            activity_risk: '',
            activity_time: '',
            activity_pratiques_pros: [],
            activity_connaissances: [],
            activity_comportements: [],
          },
        ],
        lecture: '',
        ecriture: '',
        calcul: '',
        informatique: '',
        communication: '',
        autres: '',
        rome: '',
        rsfp: '',
        rncp: '',
        convention_collective: '',
      },
      isInvertActivitiesMenuDisplayed: false,
      isFlash: {
        task: -1,
        pratique: -1,
        connaissance: -1,
        comportement: -1,
      },
      isDraggable: true,
      saving: false,
      constants: Constants,
    };
  },

  created() {
    this.initializeComponent();
    this.calculate_progress();
  },

  watch: {
    show() {
      if (this.showing) {
        this.initializeJob();
      } else {
        this.unload();
      }
    },
    form: {
      handler() {
        if (this.justLoaded) {
          this.saved = true;
          this.justLoaded = false;
        } else {
          this.saved = false;
        }
      },
      deep: true,
    },
  },

  computed: {
    activityTitle() {
      const formActivityName = this.form.activities[this.currentActivity]?.activity_name;
      const activityName = formActivityName === '' ? 'Nom de l\'activité' : formActivityName;
      const activityNumber = this.currentActivity + 1;

      return `Activité ${activityNumber} : ${activityName}`;
    },

    ...mapGetters({
      allowed: 'app/allowed',
    }),

    showing: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit('mutateShow', newValue);
      },
    },

    jobId: {
      get() {
        return this.id;
      },
      set(newValue) {
        this.$emit('mutateId', newValue);
      },
    },

    listFamilies() {
      if (this.currentSector == '' || this.currentSector === null) {
        let allFamilies = [];
        for (let cat in this.categories) {
          for (let st in this.categories[cat].families) {
            allFamilies.push({
              value: this.categories[cat].families[st].value,
            });
          }
        }
        allFamilies.sort(function (a, b) {
          if (a.value > b.value) {
            return 1;
          } else if (a.value < b.value) {
            return -1;
          } else {
            return 0;
          }
        });
        return allFamilies;
      } else {
        return this.categories.filter((v) => v.value == this.currentSector)[0]
          .families;
      }
    },

    risk(val) {
      if (val === 'Oui') {
        return true;
      }
    },

    dragOptions() {
      return {
        animation: 500,
        disabled:
          !this.editable ||
          !this.$can(Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER) ||
          !this.isDraggable,
        ghostClass: 'bg-indigo-300',
      };
    },
  },

  methods: {
    ...mapMutations({
      calculate_progress: 'neopass/calculate_progress',
    }),

    async load_sectors(context) {
      await axios
        .get('api/datatype/sectors')
        .then((response) => {
          this.categories = response.data.data;
        })
        .catch((error) => {
          console.log('ERRRR:: ', error.response);
        });
    },

    async save_datas() {
      this.saving = true;
      if (
        this.form.nom_du_poste === '' ||
        this.form.nom_du_poste === null ||
        this.form.nom_du_poste === undefined
      ) {
        this.messageHeader = 'noName';
        setTimeout(() => {
          this.messageHeader = '';
        }, 3000);
      } else {
        await axios
          .put('/api/sheets/' + this.jobId, { data: this.form })
          .then((response) => {
            this.messageHeader = 'saveIsSuccess';
            this.saved = true;
            setTimeout(() => {
              this.messageHeader = '';
            }, 3000);
          })
          .catch((error) => {
            this.saving = false;
            console.log(error.response.status);
            if (error.response.status === 403) {
              this.messageHeader = 'evaluationInProgress';
              setTimeout(() => {
                this.messageHeader = '';
              }, 3000);
              return;
            }
            this.messageHeader = 'error';
            setTimeout(() => {
              this.messageHeader = '';
            }, 3000);
            console.log('ERRRR:: ', error);
          });
      }
      this.saving = false;
    },

    initializeComponent() {
      this.load_sectors();
      this.form = this.emptyForm;
    },

    setIndex(inputValue) {
      this.currentSector = inputValue;
    },

    initializeJob() {
      if (Number.isInteger(this.jobId)) {
        this.form = this.emptyForm;
        this.editable = this.openedFromEditButton;
        this.loadData();
      } else {
        throw new Error('Trying to open a desc without giving its ID');
      }
    },

    displayActivitylist() {
      this.showList = !this.showList;
    },

    reduceProgressBar(event) {
      let el = event.target;
      this.smallBar = el.scrollTop > 10;
    },

    closePopup() {
      if (this.saved === false) {
        this.messageHeader = 'noSave';
      } else {
        this.currentActivity = 0;
        this.messageHeader = '';
        this.saved = true;
        this.unload();
      }
    },

    closeWithoutSaving(e) {
      this.currentActivity = 0;
      this.messageHeader = '';
      this.saved = true;
      this.unload();
    },

    cancel_nosave() {
      this.messageHeader = '';
    },

    deleteActivity() {
      if (this.form.activities.length > 1) {
        this.form.activities.splice(this.currentActivity, 1);
        let i = this.form.activities.length - 1;
        this.currentActivity = i;
      } else {
        this.messageHeader = 'lastActivity';
        setTimeout(() => {
          this.messageHeader = '';
        }, 3000);
      }
    },

    async loadData() {
      this.loadingData = true;
      await axios
        .get('/api/sheets/' + this.jobId)
        .then((response) => {
          this.form = response.data.data;
          this.justLoaded = true;
          this.loadingData = false;
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    unload() {
      this.showing = false;
    },

    addActivity() {
      let i = this.form.activities.length;
      this.form.activities.push({
        activity_comportements: [],
        activity_connaissances: [],
        activity_evolution: '',
        activity_level: '',
        activity_name: 'Nom de l\'activité',
        activity_posture: '',
        activity_pratiques_pros: [],
        activity_risk: '',
        activity_risktype: '',
        activity_situation: '',
        activity_tasks: [],
        activity_time: '',
        activity_tools: [],
      });
      this.currentActivity = i;
    },

    addToActivity(what) {
      what.push({
        name: '',
      });
    },

    deleteFromActivity(where, what) {
      where.splice(what, 1);
    },

    displayInvertActivitiesMenu() {
      this.isInvertActivitiesMenuDisplayed = true;
    },

    hideInvertActivitiesMenu() {
      this.isInvertActivitiesMenuDisplayed = false;
    },

    duplicateTask(task, index) {
      this.form.activities[this.currentActivity].activity_tasks.splice(
        index,
        0,
        task
      );
      this.isFlash.task = index + 1;
      setTimeout(() => {
        this.isFlash.task = -1;
      }, 1000);
    },

    duplicatePratique(prat, index) {
      this.form.activities[this.currentActivity].activity_pratiques_pros.splice(
        index,
        0,
        prat
      );
      this.isFlash.pratique = index + 1;
      setTimeout(() => {
        this.isFlash.pratique = -1;
      }, 1000);
    },

    duplicateConnaissance(conn, index) {
      this.form.activities[this.currentActivity].activity_connaissances.splice(
        index,
        0,
        conn
      );
      this.isFlash.connaissance = index + 1;
      setTimeout(() => {
        this.isFlash.connaissance = -1;
      }, 1000);
    },

    duplicateComportement(comp, index) {
      this.form.activities[this.currentActivity].activity_comportements.splice(
        index,
        0,
        comp
      );
      this.isFlash.comportement = index + 1;
      setTimeout(() => {
        this.isFlash.comportement = -1;
      }, 1000);
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
